import { FormAttribute } from '@/shared/forms/form-attribute.decorator'
import { maxLength, required } from 'vuelidate/lib/validators'

export class MessageForm {
  @FormAttribute({
    validators: {
      required,
      maxLength: maxLength(65536),
    },
  })
  public content!: string

  @FormAttribute({
    validators: {
      required,
    },
  })
  public receiver!: number
}
